import { all, takeLatest, select, call, put } from '@redux-saga/core/effects';
import { fetchIntegrations } from '../../routines/integrations/integrationDataRoutines';
import { selectLoggedInUser } from '../../selectors/userSelector';
import { request } from '../../../common/util/RestClient';
import envConfig from '../../../config';

function* fetchIntegrationsSaga() {
  try {
    const { userId } = yield select(selectLoggedInUser);

    const {
      data: { integrations: user },
    } = yield call(
      request,
      `${envConfig.APIG_URL}integration/users/${userId}/service-integrations`
    );

    const {
      data: { integrations: tenant },
    } = yield call(
      request,
      `${envConfig.APIG_URL}integration/service-integrations`
    );

    yield put(fetchIntegrations.success({ user, tenant }));
  } catch (error) {
    yield put(fetchIntegrations.failure({ error }));
  }
}

export default function* root() {
  yield all([takeLatest(fetchIntegrations.TRIGGER, fetchIntegrationsSaga)]);
}
